import React, { useState, useEffect } from 'react';

const FloorModal = ({ onSubmit, onCancel, existingFloor }) => {
  const [formData, setFormData] = useState({
    floor: existingFloor ? existingFloor.floor : '', // Ensure 'floor' exists, not 'name'
    materials: existingFloor ? existingFloor.materials : '',
  });

  // Sync form data with the existingFloor prop if it changes
  useEffect(() => {
    if (existingFloor) {
      setFormData({
        floor: existingFloor.floor || '', // Ensure 'floor' is present
        materials: existingFloor.materials || '',
      });
    }
  }, [existingFloor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedData = {
      ...formData,
      floor: formData.floor.trim(),
      materials: formData.materials.trim(),
    }; // Gather form data
    onSubmit(updatedData); // Pass the updated data to the parent handler
    onCancel(); // Close modal after submission
  };

  const handleCancel = () => {
    onCancel(); // Close modal on cancel
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className="modal-title">{existingFloor ? 'Päivitä sävyä' : 'Lisää sävy'}</h2>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-form__column">
            <label htmlFor="floor-input">Sävy:</label>
            <input
              type="text"
              id="floor-input"
              name="floor"
              value={formData.floor}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="materials-input">Pintakäsittelymateriaalit:</label>
            <textarea
              id="materials-input"
              name="materials"
              value={formData.materials}
              onChange={handleChange}
              required
              rows={2}
              className="modal-input"
            />
          </div>
          <div className="modal-form__actions modal-actions--end">
            <button type="button" onClick={handleCancel} className="btn btn-ghost">
              Peru
            </button>
            <button type="submit" className="btn btn-primary">
              {existingFloor ? 'Päivitä sävy' : 'Lisää sävy'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FloorModal;
